import React, { useState } from "react";
import moment from "moment";
import locations from "../data/locations.json";
import "bootstrap/dist/css/bootstrap.min.css";

const LocationSelector = () => {
    const [selectedLocation, setSelectedLocation] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [copySuccess, setCopySuccess] = useState("");

    const handleLocationChange = (event) => {
        const location = event.target.value;
        setSelectedLocation(location);
        setCopySuccess("");

        // Nếu quận chỉ có 1 chi nhánh, tự động chọn chi nhánh đó
        if (locations[location] && locations[location].length === 1) {
            setSelectedUser(locations[location][0]);
        } else {
            setSelectedUser(null); // Reset user nếu có nhiều chi nhánh
        }
    };

    const handleUserChange = (event) => {
        const userId = parseInt(event.target.value);
        const user = locations[selectedLocation].find((u) => u.user_id === userId);
        setSelectedUser(user);
        setCopySuccess("");
    };

    const generateLink = () => {
        const time = moment().unix();
        return `https://newpearl.com.vn/dat-ban-ma-code?user_id=${selectedUser.user_id}&time=${time}`;
    };

    const copyToClipboard = () => {
        const link = generateLink();
        navigator.clipboard
            .writeText(link)
            .then(() => setCopySuccess("Liên kết đã được sao chép!"))
            .catch(() => setCopySuccess("Sao chép thất bại. Vui lòng thử lại."));
    };

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="card p-4 shadow" style={{ maxWidth: "500px", width: "100%" }}>
                <h2 className="text-center mb-4 ">
                    Tạo link đặt chờ bàn<br /> <span className="color-main">Chang Kang Kung</span>
                </h2>

                {/* Chọn Quận */}
                <div className="mb-3">
                    <label className="form-label">Chọn Quận/Tỉnh:</label>
                    <select className="form-select" onChange={handleLocationChange} value={selectedLocation}>
                        <option value="">-- Chọn Quận --</option>
                        {Object.keys(locations).map((location) => (
                            <option key={location} value={location}>
                                {location}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Chọn User */}
                {selectedLocation && locations[selectedLocation].length > 1 && (
                    <div className="mb-3">
                        <label className="form-label">Chọn chi nhánh:</label>
                        <select className="form-select" onChange={handleUserChange}>
                            <option value="">-- Chọn Chi Nhánh --</option>
                            {locations[selectedLocation].map((user) => (
                                <option key={user.user_id} value={user.user_id}>
                                    {`(user_id: ${user.user_id}) - ${user.address.trim()}`}
                                </option>
                            ))}
                        </select>
                    </div>
                )}

                {/* Thông tin chi tiết */}
                {selectedUser && (
                    <div>
                        <h4>Thông Tin Chi Tiết</h4>
                        <p>
                            Số Điện Thoại:{" "}
                            {selectedUser.phone ? (
                                <a href={`tel:${selectedUser.phone}`} className="text-primary">
                                    {selectedUser.phone}
                                </a>
                            ) : (
                                <>
                                    Chi nhánh không có số điện thoại, vui lòng gọi tổng đài{" "}
                                    <a href="tel:19008084" className="text-primary">
                                        19008084
                                    </a>
                                </>
                            )}
                        </p>
                        <p>
                            Địa Chỉ:{" "}
                            <a
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                    selectedUser.address
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary"
                            >
                                {selectedUser.address}
                            </a>
                        </p>
                        <div className="d-flex justify-content-between mt-3">
                            <a href={generateLink()} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                                Đi tới trang đặt chờ bàn
                            </a>
                            <button onClick={copyToClipboard} className="btn btn-outline-secondary">
                                Copy Link đặt chờ bàn
                            </button>
                        </div>
                        {copySuccess && <p className="text-success mt-2">{copySuccess}</p>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LocationSelector;
